<template>
    <div class="container-fluid">
        <div class="row d-lg-none">
            <div class="col-md-12 pt-5 pl-0">
                <h1 id="title">MY PROFILE</h1>
            </div>
        </div>
        <section id="nav_tab" class="">
            <div class="" id="">
                <ul class="nav nav-tabs nav-fill" id="myTab" role="tablist">
                    <li class="nav-item">
                        <a
                            class="nav-link active"
                            data-toggle="tab"
                            href="#my-information"
                            role="tab"
                            aria-controls="home"
                            aria-selected="true"
                            style="border-radius: 0"
                            >MY INFORMATION</a
                        >
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            data-toggle="tab"
                            href="#settings"
                            role="tab"
                            aria-controls="profile"
                            aria-selected="false"
                            style="border-radius: 0"
                            >SETTINGS</a
                        >
                    </li>
                </ul>
                <div class="tab-content p-3 p-md-5 " id="myTabContent">
                    <div
                        class="tab-pane fade show active"
                        id="my-information"
                        role="tabpanel"
                    >
                        <form action method="post" @submit.prevent="updateUser">
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label for="fname">First name</label>
                                    <input
                                        type="text"
                                        id="fname"
                                        v-model="form.fname"
                                        class="form-control"
                                    />
                                    <small
                                        class="invalid-feedback"
                                        v-if="errors.fname"
                                        >{{ getErrorMsg("fname") }}</small
                                    >
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="lname">Last name</label>
                                    <input
                                        type="text"
                                        id="lname"
                                        v-model="form.lname"
                                        class="form-control"
                                    />
                                    <small
                                        class="invalid-feedback"
                                        v-if="errors.lname"
                                        >{{ getErrorMsg("lname") }}</small
                                    >
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label for="email">Email address</label>
                                    <input
                                        type="email"
                                        id="email"
                                        v-model="form.email"
                                        style="background-color: #f2f2f2;"
                                        class="form-control"
                                        disabled
                                    />
                                    <small
                                        class="invalid-feedback"
                                        v-if="errors.email"
                                        >{{ getErrorMsg("email") }}</small
                                    >
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="phone">Phone number</label>
                                    <input
                                        type="text"
                                        id="phone"
                                        v-model="form.phone"
                                        class="form-control"
                                        name="phone"
                                    />
                                    <small
                                        class="invalid-feedback"
                                        v-if="errors.phone"
                                        >{{ getErrorMsg("phone") }}</small
                                    >
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-8">
                                    <label for="address">Address Line 1</label>
                                    <input
                                        type="text"
                                        id="address"
                                        v-model="form.address"
                                        class="form-control"
                                        name="address"
                                    />
                                    <small
                                        class="invalid-feedback"
                                        v-if="errors.address"
                                        >{{ getErrorMsg("address") }}</small
                                    >
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="unit_number">Unit number</label>
                                    <input
                                        type="text"
                                        id="unit_number"
                                        v-model="form.unit_number"
                                        class="form-control"
                                        name="unit_number"
                                    />
                                    <small
                                        class="invalid-feedback"
                                        v-if="errors.unit_number"
                                        >{{ getErrorMsg("unit_number") }}</small
                                    >
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-6">
                                    <label for="country">Country</label>
                                    <select
                                        id="country"
                                        v-model="form.country"
                                        class="form-control"
                                        name="country"
                                    >
                                        <option
                                            :value="country.sortname"
                                            v-for="country in countries"
                                            v-bind:key="country.id"
                                            >{{ country.name }}</option
                                        >
                                    </select>
                                    <small
                                        class="invalid-feedback"
                                        v-if="errors.country"
                                        >{{ getErrorMsg("country") }}</small
                                    >
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="postcode">Post code</label>
                                    <input
                                        type="text"
                                        id="postcode"
                                        v-model="form.postcode"
                                        class="form-control"
                                        name="postcode"
                                    />
                                    <small
                                        class="invalid-feedback"
                                        v-if="errors.postcode"
                                        >{{ getErrorMsg("postcode") }}</small
                                    >
                                </div>
                            </div>
                            <div class="form-row" v-if="form.country !== 'SG'">
                                <div class="form-group col-md-6">
                                    <label for="city">City</label>
                                    <input
                                        type="text"
                                        id="city"
                                        v-model="form.city"
                                        class="form-control"
                                        name="city"
                                    />
                                    <small
                                        class="invalid-feedback"
                                        v-if="errors.city"
                                        >{{ getErrorMsg("city") }}</small
                                    >
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="state">State</label>
                                    <input
                                        type="text"
                                        id="state"
                                        v-model="form.state"
                                        class="form-control"
                                        name="state"
                                    />
                                    <small
                                        class="invalid-feedback"
                                        v-if="errors.state"
                                        >{{ getErrorMsg("state") }}</small
                                    >
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-12">
                                    <label>Date of Birth:</label>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <select
                                                    class="form-control "
                                                    v-model="day"
                                                >
                                                    <option
                                                        v-for="day_num in days_count"
                                                        v-bind:key="day_num"
                                                        :value="day_num"
                                                        >{{ day_num }}</option
                                                    >
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <select
                                                    class="form-control "
                                                    v-model="month"
                                                    @change="changeDay"
                                                >
                                                    <option
                                                        v-for="(data,
                                                        month) in months_days"
                                                        v-bind:key="data.name"
                                                        :value="month"
                                                        >{{ data.name }}</option
                                                    >
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <select
                                                    class="form-control "
                                                    v-model="year"
                                                    @change="changeDay"
                                                >
                                                    <option
                                                        v-for="year in years"
                                                        v-bind:key="year"
                                                        :value="year"
                                                        >{{ year }}</option
                                                    >
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <small
                                        class="invalid-feedback"
                                        v-if="errors.state"
                                        >{{ getErrorMsg("birth_date") }}</small
                                    >
                                </div>
                                <div class="col-md-12 text-center">
                                    <label class="text-left"
                                        >Having issues? Contact our Membership
                                        Team from Monday to Friday (9:30am -
                                        6:30pm) at +65 3129 4331 or
                                        member@wwf.sg and we will be happy to
                                        assist you!</label
                                    >
                                    <button
                                        class="btn text-white"
                                        style="background-color: #f58220; border-radius: 7px;"
                                        @click.prevent="updateUser"
                                        id="update-info-btn"
                                    >
                                        SAVE
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div
                        class="tab-pane fade"
                        id="settings"
                        role="tabpanel"
                        aria-labelledby="media-gallery-tab"
                    >
                        <div class="row">
                            <div class="col-md-12">
                                <h3 class="mb-0 mt-5">NOTIFICATION SETTINGS</h3>
                                <div
                                    class="custom-control custom-checkbox mb-2 mt-4"
                                >
                                    <input
                                        type="checkbox"
                                        name="updates_news"
                                        id="updates_news"
                                        class="custom-control-input"
                                        v-model="formSettings.updates_news"
                                        :checked="formSettings.updates_news"
                                    />
                                    <label
                                        for="updates_news"
                                        class="custom-control-label orange"
                                    >
                                        Subscribe to project updates and news
                                        via email
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-12 mb-5" v-if="false">
                                <h3 class="mb-0 mt-5">OTHER SETTINGS</h3>
                                <div
                                    class="custom-control custom-checkbox mb-2 mt-4"
                                >
                                    <input
                                        type="checkbox"
                                        name="save_earth"
                                        id="save_earth"
                                        class="custom-control-input"
                                        v-model="formSettings.save_earth"
                                        :checked="formSettings.save_earth"
                                    />
                                    <label
                                        for="save_earth"
                                        class="custom-control-label orange"
                                    >
                                        I would like to save the earth and opt
                                        out from the physical welcome pack
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-12 text-center">
                                <button
                                    class="btn text-white"
                                    style="background-color: #f58220;"
                                    @click.prevent="updateSetting"
                                    id="update-info-btn"
                                >
                                    SAVE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
const countries = require("country-state-city/lib/country.json");
export default {
    props: ["user", "birthdate"],
    data: function() {
        return {
            day: 1,
            year: 2020,
            month: "Jan",
            months_days: {},
            years: [],
            days_count: 1,
            countries: countries,
            form: {
                user_id: this.user ? this.user.id : "",
                fname: this.user ? this.user.fname : "",
                lname: this.user ? this.user.lname : "",
                email: this.user ? this.user.email : "",
                birth_date: this.user ? new Date(this.birthdate) : "",
                phone: this.user ? this.user.phone : "",
                country: this.user ? this.user.country : "",
                postcode: this.user ? this.user.postcode : "",
                address: this.user ? this.user.address : "",
                unit_number: this.user ? this.user.unit_number : "",
                city: this.user ? this.user.city : "",
                state: this.user ? this.user.state : ""
            },
            formSettings: {
                updates_news: this.user ? this.user.updates_news : false,
                save_earth: this.user ? this.user.save_earth : false
            },
            errors: {}
        };
    },
    created() {
        console.log(this.formSettings.updates_news);
        for (let year = 1940; year <= new Date().getFullYear(); year++) {
            this.years.push(year);
        }
        this.monthsDay();
    },
    methods: {
        changeDay() {
            this.days_count = this.months_days[this.month].days;
        },
        monthsDay() {
            fetch(
                "https://raw.githubusercontent.com/brandonwamboldt/data/master/datetime/months-detailed.json"
            )
                .then(res => res.json())
                .then(res => {
                    this.months_days = res;
                    this.days_count = this.months_days[this.month].days;

                    const birthdate = this.birthdate.split("/");
                    console.log(parseInt(birthdate[1]));
                    this.day = parseInt(birthdate[1]);
                    this.month = birthdate[0];
                    this.year = birthdate[2];
                })
                .catch(error => console.log(error));
        },
        updateUser() {
            this.form.birth_date =
                this.month + " " + this.day + "," + this.year;
            this.errors = {};
            axios
                .post("/user/personal-information/edit", this.form)
                .then(response => {
                    console.log(response.data.status);
                    if (response.data.status == "success") {
                        Swal.fire(
                            "Great!",
                            "Information has been successfully updated!",
                            "success"
                        );
                    } else {
                        return false;
                    }
                })
                .catch(e => {
                    this.errors = e.response.data.errors;
                });
        },
        updateSetting() {
            this.errors = {};
            axios
                .post(
                    "/user/personal-information/edit-setting",
                    this.formSettings
                )
                .then(response => {
                    console.log(response.data.status);
                    if (response.data.status == "success") {
                        Swal.fire(
                            "Great!",
                            "Information has been successfully updated!",
                            "success"
                        );
                    } else {
                        return false;
                    }
                })
                .catch(e => {
                    this.errors = e.response.data.errors;
                });
        },
        getErrorMsg(name) {
            if (typeof this.errors != "undefined") {
                if (typeof this.errors[name] != "undefined") {
                    return this.errors[name][0];
                }
            }
        }
    }
};
</script>
<style scoped>
#nav_tab {
    position: relative;
    border-width: 4px 0 0;
    background-color: #fff;
    box-shadow: 0 0 5px 5px #00000014;
}
#nav_tab:before {
    background: none;
}
#title {
    width: fit-content;
    padding: 0 15px;
    font-family: "WWF";
    font-size: 2.5em;
    margin-left: 15px;
}
.nav-link {
    color: black;
    font-family: "WWF";
    font-size: 1.8em;
}
#update-info-btn {
    font-size: 1.1em;
    margin-top: 20px;
    background-color: #e65959;
    font-weight: bold;
}
</style>
